// src/Constants/createEmpleado.js
export const FORM_CREATE_EMPLEADO = {
  nombre: "",
  apellidoPaterno: "",
  apellidoMaterno: "",
  curp: "",
  rfc: "",
  fechaNacimiento: "",
  numeroEmpleado: "",
  numeroSeguroSocial: "",
  gradoEstudios: "",

  contactoEmergenciaNombre: "",
  contactoEmergenciaParentesco: "",
  contactoEmergenciaTelefono: "",
  contactoEmergenciaTelefonoAlterno: "",
  contactoEmergenciaDireccion: "",

  clabeNomina: "",
  bancoNomina: "",
  titularNomina: "",

  clabeAdicional: "",
  bancoAdicional: "",
  titularAdicional: "",

  puesto: "",
  area: "",
  fechaIngreso: "",
};
